import { Alert, Snackbar } from '@mui/material'
import React, { useContext, useState } from 'react'
import { StoreContext } from '../contexts/StoreProvider';

const SnackbarNotification = () => {
  const [state, dispatch] = useContext(StoreContext);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch({
      type: 'stop-notification',
    });
  };

  return (
    <Snackbar 
      open={state.notification.open} 
      autoHideDuration={6000} 
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={state.notification.severity} sx={{width: "100%"}}>
        {state.notification.notificationText}
      </Alert>
    </Snackbar>
  )
}

export default SnackbarNotification
